<template>
  <div v-if="show && data.score > 3.9">
    <a :href="data.linkToTrustPilot" target="_blank" class="trustpilot_link">
      <div :title="data.score + ' ud af 5,0'" class="grid-container trustpilot_container">
        <div class="grid-x grid-margin-x align-middle">
          <div class="show-for-medium trustpilot_wrapper">
            <div class="trustpilot_txt">
              {{ data.description }}
            </div>
            <div class="trustpilot_stars">
              <img :src="data.imageUrl" />
            </div>
            <div class="trustpilot_logo">
              <img :src="data.trustPilotLogoUrl" />
            </div>
          </div>
          <div v-if="showTrustpilotForMobile">
            <div class="cell hide-for-medium">
              <img :src="data.trustPilotLogoUrl" class="trustpilot_logo" />
            </div>
            <div class="cell hide-for-medium">
              <img :src="data.imageUrl" class="trustpilot_stars" />
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import axios from 'axios';
import Utility from '@/common/UtilityFunctions.js';

export default {
  name: 'TrustPilot',
  data() {
    return {
      show: false,
      data: {
        imageUrl: '',
        score: 0,
        numberOfReviews: 0,
        linkToTrustPilot: '',
        description: '',
        trustPilotLogoUrl: ''
      }
    };
  },
  computed: {
    showTrustpilotForMobile() {
      return this.$store.state.marketingBox.showTrustpilotForMobile;
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      axios
        .get(Utility.constants().API.trustpilot_get)
        .then((response) => {
          if (this.data !== null) {
            this.data.imageUrl = response.data.ImageUrl;
            this.data.score = response.data.Score;
            this.data.numberOfReviews = response.data.NumberOfReviews;
            this.data.linkToTrustPilot = response.data.LinkToTrustPilot;
            this.data.description = response.data.Description;
            this.data.trustPilotLogoUrl = response.data.TrustPilotLogoUrl;
          }
          this.show = true;
        })
        .catch((err) => {
          this.show = false;
          Utility.logError(err, this);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';
.trustpilot_link {
  text-decoration: none;
}

.trustpilot_container {
  float: left;
}

.trustpilot_wrapper {
  text-align: left;
  height: 100%;
  margin: 0 auto;
  position: relative;
}

.trustpilot_txt {
  display: inline-block;
  margin: 0 rem-calc(10) rem-calc(10) 0;
  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';
  font-size: rem-calc(20);
  font-weight: bolder;
  text-align: left;
  color: #000;
}

.trustpilot_stars {
  display: inline-block;
  margin: 0 rem-calc(10) rem-calc(10) 0;
  height: rem-calc(25);
  width: rem-calc(125);
  vertical-align: middle;
}

.trustpilot_logo {
  display: inline-block;
  margin: 0 0 rem-calc(10);
  width: rem-calc(100);
  vertical-align: middle;
}
</style>
